import type { StyleImageInterface } from 'mapbox-gl'
import { calculateIconColor } from './common'

export default function JobClusterPin(
  name: string,
  { scale = 1, pixelRatio = 4 } = {},
): StyleImageInterface {
  const pinDetails = name.split('__')
  const fill = pinDetails[1] ?? '#eeeeee'
  const baseSize = 24

  const pointCount = Number(pinDetails[2] ?? 0)
  let sizeModifier = 1.5
  if (pointCount > 300) {
    sizeModifier = 2
  } else if (pointCount > 100) {
    sizeModifier = 1.75
  } else if (pointCount > 50) {
    sizeModifier = 1.5
  }

  const size = baseSize * sizeModifier * pixelRatio * scale
  const strokeWidth = 1.35
  const strokeColor = '#3c3d3f'
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size
  const context = canvas.getContext('2d')
  if (!context) {
    return {
      width: size,
      height: size,
      data: new Uint8Array(size * size * 4),
    }
  }

  context.strokeStyle = strokeColor
  context.lineWidth = strokeWidth * pixelRatio
  context.fillStyle = fill

  const radius = size / 2 - strokeWidth * pixelRatio
  context.beginPath()
  context.arc(size / 2, size / 2, radius, 0, 2 * Math.PI)
  context.stroke()
  context.fill()

  context.fillStyle = calculateIconColor(fill)

  return {
    width: size,
    height: size,
    data: context.getImageData(0, 0, size, size).data,
  }
}
